<template>
  <div class="login">
    <div class="loginBox" style="z-index: 999">
      <div class="loginLeftImg">
        <img src="../assets/image/img_paint.png" alt=""/>
      </div>
      <div class="loginRightMain">
        <div class="login_main">
          <div style="height: 120px"></div>
          <p class="login_text">能耗内网数据上传系统</p>
          <div class="loginFromCon">
            <div class="loginItem">
              <div class="icon">
                <i class="iconUser"></i>
              </div>
<!--              @focus="contactNoFocus" @blur="contactNoBlur"-->
              <el-input type="text" v-model="username" placeholder="账号/手机号" @focus="contactNoFocus" @blur="" :minlength="11" :maxlength="11"></el-input>
              <img v-show="clearUsernameImg" @click="clearUsernameFun" src="../assets/image/login/icon_delete.png" class="usernameInpImg"/>
              <span v-show="contactNoFocusSpan" style="position: absolute;top: 50px;left: 17px;color: #f00;">{{contactNoSpan}}</span>
            </div>
            <div class="loginItem">
              <div class="icon">
                <i class="iconLock"></i>
              </div>
              <el-input :type="isShow" v-model="userpwd" placeholder="密码" @focus="passwordFocus" @keyup.enter.native="clickLogin">
                <!--<i slot="suffix" class="el-input__icon el-icon-view" @click="changeType(isShow)"></i>-->
              </el-input>
              <span v-show="passwordHint" style="position: absolute;top: 50px;left: 17px;color: #f00;">{{passwordHintText}}</span>
            </div>
            <button class="loginBtn" @click="clickLogin">登 录</button>
          </div>
        </div>
      </div>
    </div>
    <div class="loginBottom">
      <img src="../assets/image/img_bg.png" style="width: 100%">
    </div>
  </div>
</template>

<script>
  import { MessageBox } from 'element-ui';
  import $ from 'jquery'
    export default {
      name: "login",
      data () {
        return {
          username:'',
          userpwd:'',
          isShow:'password',
          contactNoFocusSpan:false,
          contactNoSpan:'',
          passwordHint:false,
          passwordHintText:'',
          clearUsernameImg:false,
        }
      },
      watch:{
        username:function(n,o){
          if(n !== '' && n !== undefined && n !== null && o !== '' && o !== undefined && o !== null){
            this.clearUsernameImg = true;
          }
        }
      },
      mounted(){
        this.username = sessionStorage.getItem('username');
      },
      methods:{
        clickLogin(){
          // this.$login('/user/login',{userPhone: 'admin', password: '123456'}).then(data=>{
          //   if(data.errorCode == 0){
          //     this.passwordHint = false;
          //     sessionStorage.setItem('currentUser', JSON.stringify(data.data));
          //     this.$router.push({name: 'statisticalInfoMain'});
          //   }else{
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
          //     this.passwordHint = true;
          //     this.passwordHintText = '用户名或密码错误';
          //   }
          // });
          if((this.username !== '' && this.username !== null && this.username !== undefined) && (this.userpwd !== '' && this.userpwd !== null && this.userpwd !== undefined)){
            this.$login('/user/login',{userPhone: this.username, password: this.userpwd}).then(data=>{
              if(data.errorCode === 0){
                this.passwordHint = false;
                sessionStorage.setItem('currentUser', JSON.stringify(data.data));
                this.$router.push({name: 'statisticalInfoMain'});
              }else{
                $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
                $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
                this.passwordHint = true;
                this.passwordHintText = '用户名或密码错误';
              }
            });
          }else{
            if((this.username === '' || this.username === null || this.username === undefined) && (this.userpwd === '' || this.userpwd === null || this.userpwd === undefined)){
                  $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
                  this.contactNoSpan = '请输入账号/手机号';
                  this.contactNoFocusSpan = true;
                  $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
                  this.passwordHint = true;
                  this.passwordHintText = '请输入密码';
                }else if(this.username === '' || this.username === null || this.username === undefined){
                  $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
                  this.contactNoSpan = '请输入账号/手机号';
                  this.contactNoFocusSpan = true;
                }else if(this.userpwd === '' || this.userpwd === null || this.userpwd === undefined){
                  $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
                  this.passwordHint = true;
                  this.passwordHintText = '请输入密码';
                }
          }
          // if((this.username !== '' && this.username !== null && this.username !== undefined) && (this.userpwd !== '' && this.userpwd !== null && this.userpwd !== undefined)){
          //   this.$login('/user/background/login',{userPhone: this.username, password: this.userpwd}).then(data=>{
          //     if(data.errorCode == 0){
          //       this.passwordHint = false;
          //       sessionStorage.setItem('currentUser', JSON.stringify(data.data));
          //       this.$router.push({name: 'statisticalInfoMain'});
          //     }else{
          //       $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
          //       $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
          //       this.passwordHint = true;
          //       this.passwordHintText = '用户名或密码错误';
          //     }
          //   });
          // }else{
          //   if((this.username === '' || this.username === null || this.username === undefined) && (this.userpwd === '' || this.userpwd === null || this.userpwd === undefined)){
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
          //     this.contactNoSpan = '请输入手机号';
          //     this.contactNoFocusSpan = true;
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
          //     this.passwordHint = true;
          //     this.passwordHintText = '请输入密码';
          //   }else if(this.username === '' || this.username === null || this.username === undefined){
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
          //     this.contactNoSpan = '请输入手机号';
          //     this.contactNoFocusSpan = true;
          //   }else if(this.userpwd === '' || this.userpwd === null || this.userpwd === undefined){
          //     $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').addClass('addUserInputBorder');
          //     this.passwordHint = true;
          //     this.passwordHintText = '请输入密码';
          //   }
          // }
        },
        //清空username内容
        clearUsernameFun(){
          this.username = '';
          this.clearUsernameImg = false;
        },
        //校验手机号格式
        contactNoFocus(){
          // if(this.contactNoSpan === '手机号格式不正确'){
          //   this.username = '';
          // }
          this.contactNoSpan = '';
          this.contactNoFocusSpan = true;
          // if(this.username !== '' && this.username !== null && this.username !== undefined){
          //   this.clearUsernameImg = true;
          // }
          $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').removeClass('addUserInputBorder');
        },
        contactNoBlur(){
          this.contactNoFocusSpan = false;
          let chinese = /^1(3|4|5|7|8)\d{9}$/;
          if(this.username !== '' && this.username !== null && this.username !== undefined){
            if(!chinese.test(this.username)){
              this.contactNoSpan = '手机号格式不正确';
              this.contactNoFocusSpan = true;
              $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
            }else{
              if(this.username.length >= 1 && this.username.length <= 11){
                $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').removeClass('addUserInputBorder');
              }else{
                $('.login .loginBox .loginFromCon .loginItem:nth-child(1)').addClass('addUserInputBorder');
                this.contactNoSpan = '手机号格式不正确';
                this.contactNoFocusSpan = true;
              }
            }
          }
          // this.clearUsernameImg = false;
        },
        //  光标进入密码输入框
        passwordFocus(){
          if(this.passwordHintText = '用户名或密码错误' && this.passwordHint === true){
            this.userpwd = '';
          }
          this.passwordHint = false;
          $('.login .loginBox .loginFromCon .loginItem:nth-child(2)').removeClass('addUserInputBorder');
        },
      }
    }
</script>

<style lang="scss">
  .loginItem{
    .el-input{
      .el-input__inner{
        width:305px;
        height:38px;
        border-radius:4px;
        border:0;
        color: #fff;
        margin-right: 30px;
      }
      .el-input__inner::-webkit-input-placeholder {
        color:rgba(255, 255, 255, 0.38);
      }
    }
  }
</style>
<style scoped lang="scss">
  .login {
    width: 100%;
    height: 100%;
    position: relative;
    background:rgba(18, 18, 18, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 1365px) {
      .loginBox{
        width: 100%;
        height: 100%;
        background:rgba(31, 31, 31, 1);
      }
    }
    @media screen and (min-width: 1366px) {
      .loginBox{
        width:1366px;
        height:768px;
        //background: #fff;
        background: url("../assets/image/login_img_bg.png") no-repeat center;
        border-radius:4px;
        display: flex;
      }
    }
    .loginLeftImg{
      width: 580px;
      height: 100%;
      margin-left: 100px;
      display: flex;
      justify-content: right;
      align-items: center;
      img{
        width: 580px;
        height: 445px;
      }
    }
    .loginRightMain{
      width: calc(100% - 610px);
      height: 100%;
      position: relative;
      .login_main {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 410px;
        height: 540px;
        text-align: center;
        .login_img {
          width: 72px;
          height: 72px;
          margin: 0 auto;
        }
        .login_img1 {
          width: 203px;
          height: 38px;
          margin: 17px auto;
        }
        .login_text {
          margin: 14px auto 58px;
          width: 410px;
          height: 40px;
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.87);
          line-height: 40px;
          letter-spacing: 1px;
        }
        .loginFromCon{
          display: flex;
          flex-direction: column;
          align-items: center;
          .loginItem {
            width:368px;
            height:48px;
            background: rgba(255, 255, 255, 0.16);
            border-radius:4px;
            margin-bottom: 40px;
            display: flex;
            align-items: center;
            position: relative;
            .icon{
              width: 22px;
              height: 22px;
              padding-left: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              .iconUser{
                background: url("../assets/image/login_icon_user.png") no-repeat center;
              }
              .iconLock{
                background: url("../assets/image/login_icon_password.png") no-repeat center;
              }
              i{
                display: inline-block;
                width: 16px;
                height: 16px;
              }
            }
            .usernameInpImg{
              position: absolute;
              right: 16px;
              cursor: pointer;
              z-index: 1;
            }
          }
          .addUserInputBorder{
            border: solid 1px rgba(243, 152, 0, 1);
            background:rgba(225,49,38,0.1);
          }
          .loginBtn{
            width:368px;
            height:60px;
            background:rgba(243, 152, 0, 1);
            border-radius:4px;
            font-size: 20px;
            margin-top: 20px;
            color: rgba(18, 18, 18, 1);
          }
        }
      }
    }
    .loginBottom{
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue